import { PayloadAction } from '@reduxjs/toolkit';

import { SidebarState } from 'editor/src/store/editorModules/sidebar/types';

const setIsShopifyOptionsInfoBannerDismissedReducer = (state: SidebarState, action: PayloadAction<boolean>) => {
  state.isShopifyOptionsInfoBannerDismissed = action.payload;
};

export default setIsShopifyOptionsInfoBannerDismissedReducer;
